




























































































import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import {
  ProductState,
  AddonProduct,
  AddonProductFirstOption
} from '@/product/types'
import { formatOneDecimal } from '@/common/utils/common'
import { SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES } from '@/common/constants'

export default Vue.extend({
  components: {
    BaseImage
  },
  props: {
    option: {
      type: Object as () => AddonProduct,
      required: true
    },
    selectedAddonProductId: {
      type: String || undefined,
      default: undefined
    },
    outOfStockOptions: {
      type: Object,
      default: null
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    selectedAddonFirstOptionId?: string
    isAttrExpanded: boolean
  } {
    return {
      selectedAddonFirstOptionId: undefined,
      isAttrExpanded: !this.isMobile
    }
  },
  computed: {
    storeState(): ProductState {
      return this.$store.state
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    }
  },
  watch: {
    selectedAddonProductId() {
      if (this.selectedAddonProductId !== this.option.product.id) {
        this.selectedAddonFirstOptionId = undefined
      }
    },
    selectedAddonFirstOptionId() {
      if (this.selectedAddonFirstOptionId) {
        this.$emit(
          'setSelectedAddonFirstOptionId',
          this.selectedAddonFirstOptionId
        )
      }
    }
  },
  created() {
    const initAddonFirstOptionId =
      this.storeState.addonProduct?.selectedAddonFirstOptionId
    if (initAddonFirstOptionId) {
      this.selectedAddonFirstOptionId = initAddonFirstOptionId
    }
  },
  methods: {
    formatOneDecimal,
    getFirstOptionImage(options: Readonly<AddonProductFirstOption[]>): string {
      return (
        options.find(
          option => option.id === this.selectedAddonFirstOptionId
        ) || options[0]
      ).thumbnail
    },
    isSelectedAddonFirstOption(id: string): boolean {
      return (
        this.selectedAddonProductId === this.option.product.id &&
        this.selectedAddonFirstOptionId === id
      )
    },
    setSelectAddonProduct(productId: string): void {
      if (productId) {
        this.$emit('setSelectedAddonProductId', productId)
      }
    }
  }
})
